function getConfig() {
  const envObject = {
    PROD: {
      BASE_URL: "https://api.classplusapp.com",
      BANNER_URL: "https://campaigns.classplus.co",
      API_GRAPH_URL: "https://api.classplusapp.com/cams/graph-api",
      CMS_BASE_URL: "https://cms-gcp.classplusapp.com",
      ASSET_PREFIX: "https://courses-assets-v2.classplus.co",
      ENV: "PROD",
    },
    PREPROD: {
      BASE_URL: "https://apip-preprod.classplusapp.com",
      BANNER_URL: "https://campaigns-stage.classplus.co",
      API_GRAPH_URL: "https://apip-preprod.classplusapp.com/cams/graph-api",
      CMS_BASE_URL: "https://cms-preprod.classplusapp.com",
      ENV: "PREPROD",
    }
  };

  switch (process.env.REACT_APP_ENV) {
    case "PROD":
      return envObject["PROD"];

    case "PREPROD":
      return envObject["PREPROD"];

    default:
      return envObject["PREPROD"];
  }
}
module.exports = {
    config: getConfig(),
}
